export interface ResultsRelatedFlagsI {
  isSearchFormSubmitted: boolean;
  isLoading?: boolean;
  isGoToFormSubmitted?: boolean;
  shouldFindPins?: boolean;
}

export class MapFlags {
  public isNotCovidTab?: boolean;
  public isMapButtonVisible: boolean;
  public isSearchBlockVisible?: boolean;
  public isLoggedIn?: boolean;
  public isLoading?: boolean;
  public isSearchFormSubmitted?: boolean;
  public isGoToFormSubmitted?: boolean;
  public isMapInitialized?: boolean;
  public changeZoomIfPinsNotVisible?: boolean;
  public checkWholeMapResults?: boolean;
  public disableMarkerClick?: boolean;
  public markerLocationLiteral?: string;
  public moveToNearestMarker?: boolean;
  public isInAggregationZoomRange?: boolean;
  public noResultsFoundGlobally?: boolean;

  public constructor(isMapButtonVisible: boolean) {
    this.isMapButtonVisible = isMapButtonVisible;
  }

  public setResultsRelatedFlags(resultsRelatedFlags: ResultsRelatedFlagsI): void {
    this.isSearchFormSubmitted = resultsRelatedFlags.isSearchFormSubmitted;
    this.isLoading = resultsRelatedFlags.isLoading;
    this.isGoToFormSubmitted = resultsRelatedFlags.isGoToFormSubmitted;
  }
}
